/**
 * Safely formats a cent-based amount with currency symbol.
 * Falls back to plain number if currency code is missing or invalid.
 */
export function formatCurrency(cents: number, currency: string): string {
  const value = (cents ?? 0) / 100;
  if (!currency) return value.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2});
  try {
    return new Intl.NumberFormat("en-US", {style: "currency", currency, minimumFractionDigits: 2}).format(value);
  } catch {
    return `${value.toLocaleString("en-US", {minimumFractionDigits: 2})} ${currency}`;
  }
}

/**
 * Safely formats a whole amount (not cents) with currency symbol.
 */
export function formatCurrencyRaw(amount: number, currency: string): string {
  const value = amount ?? 0;
  if (!currency) return value.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2});
  try {
    return new Intl.NumberFormat("en-US", {style: "currency", currency, minimumFractionDigits: 2}).format(value);
  } catch {
    return `${value.toLocaleString("en-US", {minimumFractionDigits: 2})} ${currency}`;
  }
}
